import React from 'react';
import styles from './SearchResults.module.scss';
import BackToTopButton from '../BackToTopButton';

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.results
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, children), /*#__PURE__*/React.createElement(BackToTopButton, null));
};

var ResultItem = function ResultItem(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("p", {
    className: styles.resultItem
  }, children);
};

var SearchResults = function SearchResults(_ref3) {
  var results = _ref3.results,
      feedbackMessage = _ref3.feedbackMessage;

  if (feedbackMessage) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ResultItem, null, feedbackMessage));
  }

  if (!results.length) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ResultItem, null, "No found any joke belongs your search term!"));
  }

  return /*#__PURE__*/React.createElement(Wrapper, null, results.map(function (result) {
    return /*#__PURE__*/React.createElement(ResultItem, {
      key: result.id
    }, result.joke);
  }));
};

export default SearchResults;